import axios from '../../helpers/axios-setup';
import { CertificationState } from '../../redux/modules/certification';

export const createNewCertification = (data: CertificationState) => axios.post('/certifications', data);
